// extracted by mini-css-extract-plugin
export default {"titulo":"EtapasTorneo_titulo__-miaI","listado":"EtapasTorneo_listado__DvD3D","etapa":"EtapasTorneo_etapa__noX25"};